import { render, staticRenderFns } from "./ArticleTable.vue?vue&type=template&id=105b484a&"
import script from "./ArticleTable.vue?vue&type=script&lang=ts&"
export * from "./ArticleTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports